import Utilities from '@Utils/utilities';
import { TAllData, TChapters } from './types';

export async function saveContactInfo(inputData: { email?: string; telephone?: string; consent?: any; interaktionDialogId?: string }) {
	const contactInfo = {
		telefon: inputData.telephone,
		email: inputData.email,
		samtykke: inputData.consent === 'on' || inputData.consent === true ? true : false,
		blockId: null,
		landlinephone: null,
		kontaktOplysningKilde: inputData.interaktionDialogId
	};

	const response = await fetch('/Profile/GemKontaktInfo', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(contactInfo)
	});

	return await response.json();
}

export async function saveSalary(inputData: { salary: string }) {
	const response = await fetch('/api/SelvbetjeningGageApi/GemGageUdenSignatur', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ gage: Utilities.removeFormatCurrency(inputData.salary) })
	});

	return await response.json();
}

export async function getRecommendationData(url: string, servicetjekType: string) {
	const response = await fetch('/api/ServicetjekNyApi/HentAnbefalinger', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelId: url, Servicetype: servicetjekType })
	});

	return await response.json();
}

export async function getChaptersData(episerverId: string, servicetype: string) {
	const response = await fetch('/api/ServicetjekNyApi/HentKapitelOversigt', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelId: episerverId, Servicetype: servicetype })
	});

	return await response.json();
}

export async function saveChapterData(episerverId: string, answers: { optionId: string; value: string; }[]) {
	const postAnswers = answers.map((e: { optionId: string; value: string; }) => {
		return { FeltId: e.optionId, FeltValue: e.value, Value: e.value };
	});

	const response = await fetch('/api/ServicetjekNyApi/SubmitServiceTjekSvar');
	JSON.stringify({ KapitelEpiserverId: episerverId, Felter: postAnswers });

	return response.json();
}

export async function createCaseLST() {
	const response = await fetch('/api/LivshaendelseGemApi/OpretSag', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ serviceType: 'LoebendeServicetjek' })
	});

	return response.json();
}

export async function createEvent(episerverId: string, name: string) {
	const response = await fetch('/api/LivshaendelseGemApi/OpretHaendelse', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ episerverId: episerverId, name: name })
	});

	return response.json();
}

export async function createCaseAST() {
	const response = await fetch('/api/LivshaendelseGemApi/OpretSag', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ serviceType: 'AarligtServicetjek' })
	});

	return response.json();
}

export async function getDepot(awaitData: boolean, text: string) {
	const response = await fetch('/api/LivshistorieApi/HentDepot', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ AfventPensionsinfoData: awaitData, Tekst: text })
	});

	return response.json();
}


export async function getData(servicetype: string): Promise<TAllData> {
	const response = await fetch('/api/ServicetjekAarligtVToApi/HentKapitelOversigt', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ servicetype })
	});

	return response.json();
}

export async function getDataYearTwo() {
	const response = await fetch('/api/ServicetjekAarligtVToApi/HentContentAndetAar', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		}
	});

	return response.json();
}

export async function getModalYearTwo() {
	const response = await fetch('/api/ServicetjekAarligtVToApi/HentModalAndetAar', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		}
	});

	return response.json();
}

export async function getPensionsinfoContent(episerverId: string, medData: boolean, servicetype: string) {

	const response = await fetch('/api/ServicetjekAarligtVToApi/HentPensionsinfoContent', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelId: episerverId, MedData: medData, Servicetype: servicetype })
	});

	return response.json();
}

export async function getVelkomstContent(servicetype: string) {

	const response = await fetch('/api/ServicetjekAarligtVToApi/HentVelkomstContent', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ Servicetype: servicetype })
	});

	return response.json();
}

export async function getBeregnerContent(episerverId: string, medData: boolean) {

	const response = await fetch('/api/ServicetjekAarligtVToApi/HentBeregnerContent', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelId: episerverId, MedData: medData })
	});

	return response.json();
}

export async function beregnSparMereOp(bidrag: number, signal: AbortSignal) {

	const response = await fetch('/api/ServicetjekAarligtVToApi/BeregnSparMereOp?bidrag=' + bidrag, {
		method: 'get',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		signal
	});

	return response.json();
}

export async function getChapter(episerverId: string, medData: boolean, servicetype: string): Promise<TChapters> {
	const response = await fetch('/api/ServicetjekAarligtVToApi/HentContentPaaId', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelId: episerverId, medData, Servicetype: servicetype })
	});

	return response.json();
}

export async function getSnack(episerverId: string, servicetype: string, answers: { inputId: string; optionId: string; value: string; }[]) {
	const snackAnswers = answers.map((e: { inputId: string; optionId: string; value: string; }) => {
		if (e.optionId) {
			return { FeltId: e.optionId, FeltValue: e.value };
		} else {
			return { FeltId: e.inputId, FeltValue: e.value };
		}
	});

	const response = await fetch('/api/ServicetjekAarligtVToApi/HentSnack', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelId: episerverId, Servicetype: servicetype, Svar: snackAnswers })
	});

	return response.json();
}


export async function saveData(episerverId: string, answers: { inputId: string; optionId: string; value: string; }[]) {
	const postAnswers = answers?.map((e: { inputId: string; optionId: string; value: string; }) => {
		if (e.optionId) {
			return { FeltId: e.optionId, FeltValue: e.value, Value: '' };
		} else {
			return { FeltId: e.inputId, FeltValue: e.value, Value: '' };
		}
	});

	const response = await fetch('/api/ServicetjekAarligtVToApi/SubmitAarligtTjekSvar', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ KapitelEpiserverId: episerverId, Felter: postAnswers })
	});

	return response.json();
}

export async function saveLstData(livsHistorieId: string, answers: { inputId: string; value: string; }[]) {
	const postAnswers = answers.map((e: { inputId: string; value: string; }) => {
		return { feltId: e.inputId, feltValue: e.value };
	});

	const response = await fetch('/api/ServicetjekLoebendeApi/SubmitServicetjekLoebendeSvar', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ livsHistorieId: livsHistorieId, felter: postAnswers })

	});

	return response.json();
}

export async function updateMessageExtended(livsHistorieId: string) {
	const response = await fetch('/api/ServicetjekLoebendeApi/HentNyeMeddelelserMedPensionsinfo', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ livsHistorieId: livsHistorieId })
	});

	return response.json();
}


export async function saveSurveyData(surveyTitle: string, answer: string) {
	const response = await fetch('/api/ServicetjekLoebendeApi/SubmitSurveySvar', {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ SurveyTitle: surveyTitle, Svar: answer })
	});

	return response.json();
}